import { defineAction } from '@cheesecakelabs/boilerplate/utils'

import * as taskService from '_services/task'

export const START_TASK = defineAction('START_TASK')
export const COMPLETE_TASK = defineAction('COMPLETE_TASK')
export const STOP_TASK = defineAction('STOP_TASK')
export const CONTINUE_TASK = defineAction('CONTINUE_TASK')
export const UPDATE_TASK_STATUS = defineAction('UPDATE_TASK_STATUS')
export const SET_CAPTURE_TASK = 'SET_CAPTURE_TASK'
export const COMPLETE_CAPTURE_ITEM = defineAction('COMPLETE_CAPTURE_ITEM')
export const CHECK_CURRENT_TASK = defineAction('CHECK_CURRENT_TASK')
export const SET_CURRENT_TASK = defineAction('SET_CURRENT_TASK')

export const startTask = payload => (dispatch, getState) =>
  dispatch({
    type: START_TASK.ACTION,
    payload: taskService.startTask(getState().user.get('token'))(payload),
  })

export const completeTask = id => (dispatch, getState) =>
  dispatch({
    type: COMPLETE_TASK.ACTION,
    payload: taskService.completeTask(getState().user.get('token'))(id),
  })

export const stopTask = id => (dispatch, getState) =>
  dispatch({
    type: STOP_TASK.ACTION,
    payload: taskService.stopTask(getState().user.get('token'))(id),
  })

export const continueTask = (id, payload) => (dispatch, getState) =>
  dispatch({
    type: CONTINUE_TASK.ACTION,
    payload: taskService
      .continueTask(getState().user.get('token'))(id, payload)
      .then(() => id),
  })

export const updateTaskStatus = id => (dispatch, getState) =>
  dispatch({
    type: UPDATE_TASK_STATUS.ACTION,
    payload: taskService.updateTaskStatus(getState().user.get('token'))(id),
  })

export const checkCurrentTask = payload => (dispatch, getState) =>
  dispatch({
    type: CHECK_CURRENT_TASK.ACTION,
    payload: taskService.checkCurrentTask(getState().user.get('token')),
  })

export const setCurrentTask = payload => dispatch =>
  dispatch({
    type: CHECK_CURRENT_TASK.ACTION,
    payload,
  })



// WEBPACK FOOTER //
// ./src/modules/current-task/actions.js